<template>
  <div id="AirOutletOthers" class="page product-list">
    <div class="page-top-container">
      <div class="select-product-block line-no-wrap">
        <span class="block-title after-line">已选规格</span>
        <el-tooltip
            :disabled="selectProduct.specification && selectProduct.specification.length < 80"
            effect="light"
            :content="selectProduct.specification"
            placement="bottom-start"
        >
          <span class="name-span">{{selectProduct.specification || '暂无'}}</span>
        </el-tooltip>
        <el-button
            v-if="selectProduct.searchData.structuresName === '球形喷口' && selectProduct.specification"
            type="text"
            @click="chooseDetail(selectProduct)"
        >查看</el-button>
      </div>
      <div class="search-bar">
        <span class="search-bar-title" @click="()=>{ isFold = !isFold }">
          <i class="el-icon-arrow-right rotate-icon" :class="{'icon-fold':isFold}" />
          选型条件
        </span>
        <gjw-dimensions @height-changed="searchBoxHeightChange">
          <div class="search-content-box" :class="{'fold-height':isFold}">
            <air-outlet-search ref="airOutletSearch" from="AirOutletOthers" :init-value="rowSearch" />
            <div class="search-btn-box">
              <el-button type="primary" size="medium" @click="reChoose">选&nbsp;&nbsp;型</el-button>
            </div>
          </div>
        </gjw-dimensions>
      </div>
    </div>
    <div class="search-innerbox">
      <el-table
        v-if="tableData.length"
        v-loading="tableLoading"
        :data="tableData"
        :max-height="tableHeight"
        :row-style="rowStyle"
        empty-text="根据您的选型条件暂无匹配的产品型号，请修改选型条件后重试"
      >
        <el-table-column
          v-for="(item, index) in headerColumn"
          :key="index"
          :prop="item.prop"
          :label="item.value"
          :width="widthParameter"
          :render-header="renderHeader"
        >
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="selectProduct.id === scope.row.id" class="iconSuccess">
              <i class="el-icon-success"></i>
              <span>已选</span>
            </div>
            <el-button
              v-else
              style="margin-right: 14px; background: #4897f5; color: #fff"
              type="button"
              size="small"
              @click="onSelectRow(scope.$index, scope.row)"
              >选择</el-button>

            <el-button
              v-if="searchData.structuresName === '球形喷口'"
              @click="chooseDetail(scope.row)"
              type="text"
              size="small"
              style="color: #4897f5"
              >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <empty-content v-else text="根据您的选型条件暂无匹配的产品型号，请修改选型条件后重试" />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        custom-class="product-detail-drawer"
        :append-to-body="true"
        :modal="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
      >
        <fan-coil-detail :productIds="productId" />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FanCoilDetail from './FanCoilDetail.vue'
import AirOutletSearch from './components/batchSelection/AirOutletSearch.vue'
import EmptyContent from '@/components/business/EmptyContent.vue'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'

export default {
  name: 'AirOutletOthers',
  props: {
    productRow: {
      type: Array,
      default() {
        return []
      },
    },
    currentRow: {
      type: Object,
      default() {
        return {}
      },
    },
    rowSearch: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  components: {
    EmptyContent,
    GjwDimensions,
    FanCoilDetail,
    AirOutletSearch,
  },
  data() {
    return {
      tableLoading: false,
      // 选型条件是否收起
      isFold: true,
      tableHeight: (document.body.clientHeight - 130).toFixed(0),
      // 房间的产品搜索条件
      searchData: {},
      isSphericalDiffuser: false,
      isSingleLayer: false,
      currentIndex: [0],
      drawer: false,
      pageSize: 50,
      productId: '',
      selectProduct: {
        searchData: {}
      },
      // 重新选型后查询结果
      reChooseProductIds: [],
      innerDrawer: false,
      direction: 'ltr',
      drawerWidth: '1040px',
      tableData: [],
      imageUrlFailed: false,
      headerColumn: [],
      // 品类编码
      gjwCategoryCode: 'C000012',
      // 品类名称
      gjwCategoryName: '末端风口',
      // 方形散流器、单层/双层百叶风口
      headerNotSpherical: [
        { prop: 'specification', value: '规格' },
        { prop: 'length', value: '长度(mm)' },
        { prop: 'width', value: '宽度(mm)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      // 圆形散流器
      roundDiffuser: [
        { prop: 'specification', value: '规格' },
        { prop: 'diameter', value: '直径(mm)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      // 球形喷口
      headerSpherical: [
        { prop: 'specification', value: '规格' },
        { prop: 'diameter', value: '直径(mm)' },
        { prop: 'nozzleThrow', value: '射程(m)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      parameter_values: {},
      widthParameter: '235px',
    }
  },
  computed: {
    ...mapGetters({
      detail: 'productDetail/detail',
    }),
    productImage() {
      return require('@/assets/image/default_product_img.png')
    },
  },
  watch: {
    currentRow: {
      handler(newValue, oldValue) {
        // 触发选型结果
        this.initPage()
      },
    },
  },

  mounted() {
    // 触发选型结果
    this.initPage()
  },

  methods: {
    ...mapActions({
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      // 性能数据
      loadCurveData: 'productDetail/loadCurveData',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    ...mapMutations({
      setProductId: 'productDetail/setProductId',
    }),

    // 初始化页面
    initPage() {
      // 如果未找到合适规格，则不展示表格
      if (this.currentRow.id) {
        const data = this.$refs.airOutletSearch.getSearchData()
        this.searchData = { ...data.searchData }
        this.isSphericalDiffuser = data.isSphericalDiffuser
        this.isSingleLayer = data.isSingleLayer
        this.getTableList()
      } else {
        this.selectProduct = {
          searchData: {}
        }
        this.reChooseProductIds = []
        this.tableData = []
      }
    },

    // 获取tableData
    getTableList(from, productIds) {
      const isReChoose = from === 'reChoose'
      if (this.searchData.structuresName === '球形喷口') {
        this.widthParameter = '233px'
        this.headerColumn = this.headerSpherical
      } else if (this.searchData.structuresName === '圆形散流器') {
        this.widthParameter = '310px'
        this.headerColumn = this.roundDiffuser
      } else {
        this.widthParameter = '232px'
        this.headerColumn = this.headerNotSpherical
      }
      this.parameter_values = {
        productIds: isReChoose ? productIds : this.productRow,
        airSupplyVolume: this.currentRow.airSupplyVolume,
        equipmentNumber: this.currentRow.equipmentNumber || this.currentRow.calEquipmentNumber,
        roomArea: this.currentRow.roomArea,
        singleUnitResponsibilityArea: Number(this.searchData.singleUnitResponsibilityArea),
        parameter_filter:
            this.searchData.structuresName === '球形喷口'
              ? 'SPHERICAL_DIFFUSER'
              : 'OBS_DIFFUSERS',
      }
      this.$api.products.parameter_AirOutlet_values(this.parameter_values)
        .then((res) => {
          const that = this
          that.tableData = JSON.parse(JSON.stringify(res))
          that.tableData.forEach((v) => {
            v.parameters.forEach((j) => {
              if (j.code === 'P000303') {
                v.specification = j.value
              }
              if (j.code === 'P000014') {
                v.length = j.value
              }
              if (j.code === 'P000015') {
                v.width = j.value
              }
              // 直径
              if (j.code === 'P000160') {
                v.diameter = j.value
              }
              if (j.code === 'P000209') {
                v.nozzleThrow = j.value
              }
              if (j.code === 'P000306') {
                v.outletVelocity = j.value
              }
            })
          })
          that.tableData.forEach((v) => {
            if (!v.length) {
              v.length = '- -'
            }
            if (!v.specification) {
              v.specification = '- -'
            }
            if (!v.width) {
              v.width = '- -'
            }
            if (!v.outletVelocity) {
              v.outletVelocity = '- -'
            }
            if (!v.diameter) {
              v.diameter = '- -'
            }
            if (!v.nozzleThrow) {
              v.nozzleThrow = '- -'
            }
          })
          if (!isReChoose) {
            this.selectProduct = that.tableData.find((item) => { return item.id === this.currentRow.id }) || {}
            this.selectProduct.searchData = { ...this.currentRow.searchData }
            this.reChooseProductIds = [...this.productRow]
          }
        }).finally(() => {
          this.tableLoading = false
        })
    },

    // 改变查询条件后，重新选型
    reChoose() {
      this.tableLoading = true
      const data = this.$refs.airOutletSearch.getSearchData()
      this.searchData = { ...data.searchData }
      this.isSphericalDiffuser = data.isSphericalDiffuser
      this.isSingleLayer = data.isSingleLayer
      const productProperties = []
      productProperties.push(
        {
          code: 'P000205',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: this.searchData.structuresCode,
        },
        {
          code: 'P000306',
          parameterType: 'Double',
          queryType: 'RANGE_TE',
          from: String(this.searchData.fromVelocity),
          to: String(this.searchData.toVelocity),
        }
      )

      if (this.isSphericalDiffuser) {
        // 喷口射程
        productProperties.push({
          code: 'P000209',
          parameterType: 'Double',
          queryType: 'EQUAL',
          value: this.searchData.nozzle_throw,
        })
      }
      const roomInfo = [
        {
          airSupplyVolume: this.currentRow.airSupplyVolume,
          roomArea: this.currentRow.roomArea,
          roomCode: this.currentRow.roomCode,
          roomId: this.currentRow.roomId,
          roomName: this.currentRow.roomName,
        }
      ]
      this.paramsForMulti_room = {
        topSize: this.pageSize,
        aspectRatioFrom: this.isSingleLayer ? Number(this.searchData.aspectRatioFrom) : null,
        aspectRatioTo: this.isSingleLayer ? Number(this.searchData.aspectRatioTo) : null,
        brandCode: this.searchData.brandCode,
        inputCondition: roomInfo,
        productProperties: productProperties,
        singleUnitResponsibilityArea: Number(this.searchData.singleUnitResponsibilityArea),
      }
      this.$api.products.getMulti_room(this.gjwCategoryCode, this.paramsForMulti_room).then((res) => {
        this.reChooseProductIds = res[0].productIds
        if (this.reChooseProductIds && this.reChooseProductIds.length) {
          this.getTableList('reChoose', this.reChooseProductIds)
        } else {
          this.tableLoading = false
          this.tableData = []
        }
      }).catch(() => {
        this.tableLoading = false
        this.$msgbox(
          '存在不合理的输入值，请检查是否符合实际情况并重新输入。',
          '提示',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
            },
          }
        )
      })
    },
    searchBoxHeightChange(obj) {
      const height = obj.newValue || 0
      const maxHeight = document.body.clientHeight - height - 130
      this.tableHeight = maxHeight.toFixed(0)
    },
    // 选择
    onSelectRow(index, row) {
      this.selectProduct = row
      this.selectProduct.searchData = { ...this.searchData }
      const obj = {
        row: { ...this.selectProduct, productIds: this.reChooseProductIds },
        index: index
      }
      this.$emit('selectRow', obj)
      // 选择备选结果埋点
      this.$tracks({
        event: 'selectAlternative',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
        },
      })
    },

    // 设置行样式
    rowStyle({ row }) {
      let rowStyle = { height: '40px' }
      if (this.selectProduct.id === row.id) {
        rowStyle = { ...rowStyle, background: '#E9F2FE' }
      }
      return rowStyle
    },

    // 查看详情
    async chooseDetail(v) {
      this.drawer = true
      this.setProductId(v.id)
      // 获取产品ID
      this.productId = JSON.parse(JSON.stringify(v.id))
      // 获取产品详情
      this.loadProperties().then()
      this.loadDetail().then()
      this.loadCurveData(this.productIds).then() // 基础选型不包含性能数据处理
      // 展示性能数据
      this.loadRelatedComponents().then()
      this.loadRelatedBlocks().then()
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: v.id,
          g_c_product_name: v.name,
          g_c_source: 'alternative',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },

    // 处理表格列头
    renderHeader(h, { column, $index }) {
      // 这里在最外层插入一个div标签
      if (column.label === '射程(m)') {
        return h('div', [
          // 在div里面插入span
          h('span', {
            // 表示内容
            domProps: {
              innerHTML: column.label,
            },
            on: {
              click: () => {
                console.log(`${column.label}   ${$index}`)
              },
            },
          }),
          h(
            'el-tooltip',
            {
              // 表示属性
              attrs: {
                effect: 'dark',
                content: '根据产品性能数据估算',
                placement: 'top',
              },
            },
            [
              h('i', {
                class: 'el-icon-question table-msg',
              }),
            ]
          ),
        ])
      }
      return h('div', [
        // 在div里面插入span
        h('span', {
          // 表示内容
          domProps: {
            innerHTML: column.label,
          },
        }),
      ])
    },
  },

}
</script>

<style lang="less" scoped>
.product-list {
  width: 1120px !important;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
  .search-innerbox {
    width: 1080px;
    margin: 0 20px;
    flex: none;
  }
}
.page-top-container{
  padding: 0 20px;
}
.select-product-block{
  background: #E9F2FE;
  border-radius: 6px;
  padding: 0 14px;
  margin-bottom: 10px;
  height: 32px;
  line-height: 32px;
  .block-title{
    margin-right: 10px;
    padding-right: 10px;
  }
  .name-span{
    margin-right: 10px;
  }
}
.search-bar{
  margin-bottom: 8px;
}
.search-bar-title{
  color: #009ee1;
  cursor: pointer;
  .rotate-icon {
    display: inline-block;
    transform: rotate(90deg);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &.icon-fold {
      transform: rotate(0deg);
    }
  }
}
.search-content-box{
  box-sizing: border-box;
  border-top: 1px solid #d2d9e3;
  margin: 8px 0;
  height: 120px;
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  &.fold-height{
    height: 0;
    border: none;
  }
}
.search-btn-box{
  margin-top: 8px;
  text-align: right;
}

.select-input {
  width: 108px;
}
.keyword-label {
  margin: 0 6px 0 16px;
}
.search-label {
  margin-right: 8px;
}
.narrow {
  width: 73px;
}
.line_left {
  height: 16px;
  padding-right: 8px;
  border-left: 1px #ccc solid;
}
/deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}
/deep/div.search-innerbox .has-gutter tr {
  height: 40px !important;
}
/deep/div.search-innerbox .el-table__header-wrapper {
  height: 40px !important;
}
/deep/div.search-innerbox .el-table__row {
  height: 64px !important;
}
/deep/.el-table th {
  padding: 0 !important;
}
/deep/.el-table td {
  padding: 0 !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}
.el-row {
  text-align: right;
}
.iconSuccess {
  display: unset;
  margin-right: 18px;
  height: 32px;
  width: 60px;
}
.search-innerbox .el-row .el-button {
  margin-right: 14px;
  border-radius: 2px;
  color: #fff;
  height: 32px;
  background: #4897f5;
  width: 60px;
}
.lectotype {
  color: #fff;
  background: #409eff;
}
.confirm {
  color: #2dafcd !important;
}
.lectotype:hover {
  background: #2dafcd;
}
.el-icon-success {
  margin: 0 8px;
  color: #4897f5;
}
.model-container {
  .product-img {
    width: 54px;
    height: 54px;
    margin-left: 10px;
    margin-top: 5px;
    background: #f3f3f3;
  }
  .modeproductSeries {
    top: 30px;
  }
  .table-msg {
    padding-left: 6px;
  }
}
</style>
